export const ModalName = {
  WELCOME: "welcome",
} as const;
